export default __webpack_public_path__ + "images/private_project_image-dHtJU.png";